<template>
    <div class="row p-1">
        <div class="col-md-4">
            <div class="row">
                <div class="form-group col-md-12" v-if="isInvestment">
                    <label>Yatırım Tipi</label>
                    <select class="form-control" v-model="bonusOdds.yatirimTipiId">
                        <option :value="null" disabled selected>Yatırım Tipi Seçiniz</option>
                        <option
                            :value="type.ID"
                            v-for="type in investmentTypes"
                            :key="type.ID"
                        >{{ type.name }}</option>
                    </select>
                </div>
                <div class="form-group col-md-12" v-if="!isInvestment">
                    <label>Alt Limit</label>
                    <input
                        type="number"
                        min="0"
                        v-model="bonusOdds.altLimit"
                        class="form-control"
                        placeholder="Alt Limit"
                    />
                </div>
                <div class="form-group col-md-12" v-if="!isInvestment">
                    <label>Üst Limit</label>
                    <input
                        type="number"
                        min="0"
                        v-model="bonusOdds.ustLimit"
                        class="form-control"
                        placeholder="Üst Limit"
                    />
                </div>
                <div class="form-group col-md-12" v-if="!isInvestment">
                    <label>Oran Tipi</label>
                    <select
                       
                        v-model="bonusOdds.type"
                        class="form-control"
                    >
                        <option :value="0">Tip Seçiniz</option>
                        <option :value="0">Tüm Kayıplar</option>
                        <option :value="1">Spor Kayıp</option>
                        <option :value="2">Casino Kayıp</option>
                    </select>
                </div>
                <div class="form-group col-md-12">
                    <label>Bonus Oranı</label>
                    <input
                        type="number"
                        min="0"
                        v-model="bonusOdds.oran"
                        class="form-control"
                        placeholder="Bonus Oran"
                    />
                </div>
                <div class="form-group col-md-12">
                    <button class="btn col-12 btn-primary" @click="addOdds(bonusOdds)">Ekle</button>
                </div>
            </div>
        </div>
        <div class="col-md-8 mt-3">
            <div class="table-responsive">
                <table class="table table-hover table-striped">
                    <thead>
                        <tr>
                            <th>{{ isInvestment ? 'Yatırım Tipi' : 'Alt Limit- Üst Limit' }}</th>
                            <th>Oran</th>
                            <th>İşlemler</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="odd in oddsArray" :key="odd.ID">
                            <td>{{ isInvestment ? odd.name : odd.min + '-' + odd.max }} <span v-if="!isInvestment"> ( <span v-if="odd.type==0 || odd.type==3">Tüm Kayıplar</span><span v-else-if="odd.type==1">Spor Kayıplar</span><span v-else-if="odd.type==2">Casino Kayıplar</span> ) </span></td>
                            <td>%{{ odd.oran }}</td>
                            <td>
                                <button class="btn btn-sm btn-danger" @click="deleteOdd(odd.ID)">  <i class="fas fa-trash"></i></button>
                            </td>
                        </tr>
                        <tr v-if="oddsArray.length == 0">
                            <td  colspan="3" class="text-center">Kayıt Bulunamadı</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            investmentTypes: [],
            oddsArray: [],
            bonusName: "",
            bonusOdds: {
                kampanyaId: 0,
                kampanyaType: 0,
                yatirimTipiId: null,
                ustLimit: null,
                altLimit: null,
                oran: null,
                type: 0
            }
        }
    },
    methods: {
        getBonus() {
            //**bonus id ye göre name,kampanyatur bilgilerini almak için */
            this.$http.get(`Bonus/GetBonus/` + this.$route.params.id ).then((response) => {
                this.bonusName = response.data.name;
                this.bonusOdds.kampanyaId = response.data.ID;
                this.bonusOdds.kampanyaType = response.data.gelenKampanyaTur;
            })
        },
        getInvestmentType() {
            //**yatırım tiplerini select boxta kullanmak için */
            this.$http.post("Bonus/ListYatirimTipi", {}).then((response) => {
                this.investmentTypes = response.data;
            })
        },
        getByIdOdds() {
            //**bonus id ye göre oran listeleri */
            this.$http.post("Bonus/ListBonusOran", { id: this.$route.params.id }).then((response) => {
                this.oddsArray = response.data;
            })
        },
        addOdds(_odds) {
            //**bonus oran ekleme */
            this.$http.post("Bonus/AddBonusOran", _odds).then((response) => {
                toastr.success("Bonus Oran Eklendi.");
                this.bonusOdds.yatirimTipiId = null;
                this.bonusOdds.ustLimit = null;
                this.bonusOdds.altLimit = null;
                this.bonusOdds.oran = null;
                this.bonusOdds.type = 0;
                this.getByIdOdds();
            },(err) => {
                toastr.error(err.data.Message);
            });
        },
        deleteOdd(_id){
            //**bonus oran silme */
             Swal.fire({
                title:
                    "Oran kalıcı olarak silinecek!Onaylıyor musunuz?",
                showCancelButton: true,
                confirmButtonText: "Evet! Silinsin",
                cancelButtonText: "İptal",
                icon: "question",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$http.get(`Bonus/DeleteBonusOran?ID=${_id}&kampanyaId=${this.bonusOdds.kampanyaId}`).then((response) => {
                        this.getByIdOdds();
                        toastr.success("İşlem başarılı.");
                    }, (err) => {
                        toastr.error(err.data.Message);
                    });
                }
            });
        }

    },
    computed: {
        isInvestment() {
            //**kampyanya tipine göre inputları filtrelemek için */
            //**true ise yatırım tiplerini göster,false ise alt limit üst limit göster */
            if (this.bonusOdds.kampanyaType == 1 || this.bonusOdds.kampanyaType == 3 || this.bonusOdds.kampanyaType == 5) {
                return true;
            } else {
                return false;
            }
        }
    },
    created() {
        this.getBonus();
        this.getInvestmentType();
        this.getByIdOdds()
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/BonusList/BonusTabs/BonusOddsSettings.vue